import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { ToastContainer } from 'react-toastify'
import { fetchPermissions } from '../actions/auth'

function RequirePermission(ComposedComponent) {
  class Permission extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      menu: PropTypes.object.isRequired,
      user: PropTypes.object,
      fetchPermissions: PropTypes.func,
      allowedChildRoutes: PropTypes.object,
    }

    extractAllowedMenuRoutes = (items, depth = 0) => {
      if (depth <= 5) {
        return items.reduce((allowedRoutes, { dsView, subItems }) => {
          if (dsView) allowedRoutes.push(dsView)
          if ((subItems || []).length)
            allowedRoutes = allowedRoutes.concat(
              this.extractAllowedMenuRoutes(subItems, depth + 1)
            )
          return allowedRoutes
        }, [])
      }
      return []
    }

    exctractAllAllowedRoutes = (allowedRoutes) => {
      const { allowedChildRoutes } = this.props
      const allAllowed = []
      allowedRoutes.map((item) => {
        allowedChildRoutes &&
          allowedChildRoutes[item] &&
          allAllowed.push(allowedChildRoutes[item])
      })
      allAllowed.push(allowedRoutes)
      return allAllowed.flat(1)
    }

    checkForPermission = (menuItems, path) => {
      path = path.replace(/\/\d+/, '/') // removes the ID from the end of the path, eg suggestions/123 => suggestions/
      return this.exctractAllAllowedRoutes(
        this.extractAllowedMenuRoutes(Object.values(menuItems))
      ).includes(path)
    }

    async componentDidMount() {
      const { menu, dispatch, user, fetchPermissions } = this.props
      await fetchPermissions(user.dsToken)
      if (
        !this.checkForPermission(menu, window.location.pathname.substring(1))
      ) {
        console.warn('USUARIO SEM PERMISSÃO PARA ESSA ROTA')
        dispatch(
          push({
            pathname: '/home',
            state: { notAllowed: true },
          })
        )
      }
    }

    render() {
      return (
        <>
          <div>
            <ComposedComponent {...this.props} />
            <ToastContainer newestOnTop />
          </div>
        </>
      )
    }
  }

  function mapStateToProps({ menuReducer, auth }) {
    return {
      menu: menuReducer.menu,
      user: auth.user,
      allowedChildRoutes: auth.allowedChildRoutes,
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchPermissions }, dispatch)
  }

  /*
   * Connects component to I18next
   */
  const PermissionTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate',
  })(Permission)

  return connect(mapStateToProps, mapDispatchToProps)(PermissionTranslated)
}

export default RequirePermission
